import { NavItem } from './nav-item';

export class DropDownNavItem extends NavItem {}
